import {
    StyledProjectDetailsDialogHeader,
    StyledProjectDetailsDialogHeading
} from '@/features/projects/components/project-details-dialog-atoms/style'
import {DialogHeadingProps} from '@ariakit/react'

export const ProjectDetailsDialogHeader = (props: DialogHeadingProps) => {
    return <StyledProjectDetailsDialogHeader {...props} />
}

export const ProjectDetailsDialogHeading = (props: DialogHeadingProps) => {
    return <StyledProjectDetailsDialogHeading {...props} />
}
